import { Trans, t } from "@web-monorepo/i18n/macro";
import { DDSBodyText, DDSDisplayText, DDSIconButton } from "@web-monorepo/dds";
import { IconChevronLeft } from "@web-monorepo/dds-icons";
import { getImageSrc } from "@web-monorepo/static-assets";
import styles from "./WhatIsDojoCast.module.css";

const welcome = getImageSrc("toolkit/src/pods/help/assets/bitmap@2x.png");

export default function WhatIsDojoCast() {
  return (
    <section className={styles.page}>
      <div className={styles.imageContainer}>
        <DDSIconButton
          data-name="what_is_dojo_cast:material_icon"
          onClick={() => window.history.back()}
          variant="tertiary"
          aria-label={t`Back`}
          tooltip={{ content: t`Back`, dataName: "what_is_dojo_cast:back_tooltip" }}
          className={styles.backButton}
        >
          <IconChevronLeft size="m" />
        </DDSIconButton>
        <img src={welcome} className={styles.image} alt="" />
      </div>
      <DDSDisplayText level="md" as="h1" className={styles.title}>
        <Trans>DojoCast</Trans>
      </DDSDisplayText>
      <DDSBodyText as="p" className={styles.body}>
        <Trans>
          Toolkit's magic happens when you log into the ClassDojo website from a computer or smartboard. With DojoCast,
          every time you use a tool in the app - like Timer, Directions, or Think Pair Share - it's automatically
          projected in front of the class. Don't want to display? Just tap "stop DojoCast". So step away from your desk.
          You're now free to move about the classroom :)
        </Trans>
      </DDSBodyText>
    </section>
  );
}
